import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function TechnicalChecklistPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>Technical SEO Checklist | OptiSiteSEO</title>
        <meta
          name="description"
          content="A concise technical SEO checklist: indexing, crawlability, metadata, structured data, performance, and foundational discoverability signals."
        />
        <link rel="canonical" href={canonicalUrl("/technical-seo-checklist")} />
      </Helmet>

      <section className="card section">
        <p className="eyebrow">Technical SEO checklist</p>
        <h1>The essentials we check automatically</h1>
        <ul className="bullets">
          <li>Robots, canonicals, redirects</li>
          <li>Titles, descriptions, OpenGraph</li>
          <li>Performance risk hints (LCP/CLS)</li>
          <li>Sitemap, HTTPS, reachability</li>
        </ul>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            See the output
          </a>
        </div>
      </section>
    </div>
  );
}
